import type { ReactNode } from "react";

export const GuideBefore = ({ children }: { children: ReactNode }) => (
  <div className="mt-4 border-l-2 border-line pl-4 [&>:first-child]:mt-0">
    <p>
      <strong>Before you start</strong>
    </p>
    {children}
  </div>
);
